import React from 'react';
import { useCanvas } from '../../hooks/useCanvas';

interface CanvasProps {
  draw: (ctx: CanvasRenderingContext2D, width: number, height: number, context: unknown) => void;
  options: {
    context: unknown;
    predraw: (
      ctx: CanvasRenderingContext2D,
      canvas: HTMLCanvasElement,
      size: { height: number; width: number },
    ) => void;
    postdraw: () => void;
  };
  size: { width: number; height: number };
}

export const Canvas = (props: CanvasProps) => {
  const { draw, options, size } = props;
  const { context, ...helpers } = options;

  const canvasRef = useCanvas(draw, { context, helpers, size });

  return <canvas ref={canvasRef} />;
};
